module.exports = __webpack_public_path__ + "static/media/icon_pmh_active.eee26afb.svg";